"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : CONTENT TYPE --------------- ++++++++++ */


var badgeSpaceSize = 7;
var _default = {
  badge: {
    background: _index.theme.color.primary.medium.swatch,
    color: '#fff',
    borderRadius: '12px',
    height: '24px',
    padding: '0 10px',
    fontSize: '10px',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    // ----- types ----- //
    '&.type-new': {
      background: 'rgb(255, 174, 34)',
      color: '#fff'
    },
    // ----- space ----- //
    '&.space': {
      '&-left': {
        marginLeft: (0, _index.pxToEm)(badgeSpaceSize)
      },
      '&-right': {
        marginRight: (0, _index.pxToEm)(badgeSpaceSize)
      },
      '&-around': {
        marginLeft: (0, _index.pxToEm)(badgeSpaceSize),
        marginRight: (0, _index.pxToEm)(badgeSpaceSize)
      }
    },
    // ----- colors ----- //
    // generates classes for every color in the theme ".color-(uniqueColor)"
    extend: (0, _index.themeStyleHelper)(_index.theme, 'color', function (theme, uniqueColor) {
      return {
        background: theme.color[uniqueColor].medium.swatch,
        color: theme.color[uniqueColor].medium.contrast
      };
    })
  }
};
exports.default = _default;